<template>
  <div class="page-view">
    <div class="scroll-view-wrapper rank-view">
      <div class="rank-view-top"></div>
      <div class="rank-view-container">
        <e-header
          v-show="!utils.isApp()"
          :showBtn="false"
          :showShare="false"
          title="排行榜"
          bgColor="transparent"
          @share="footerAction"
        ></e-header>

        <div class="rank-nav">
          <div class="tabBox">
            <div
              class="tab-item"
              v-for="item in topList"
              :key="item.id"
              @click="navAction(item.id, item.type)"
              :class="{ active: topId == item.id }"
            >
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div
          class="no-data-box"
          v-if="!state.hotList.length && !state.rankList.length"
        >
          <no-data />
        </div>

        <div class="rank-top-wrapper" v-if="state.hotList.length">
          <div class="rank-top">
            <doctor-top :hotList="state.hotList"></doctor-top>
          </div>
        </div>
        <doctor-list
          :rankList="state.rankList"
          :isApp="isApp"
          :userInfo="state.userInfo"
        ></doctor-list>

        <div class="ui-footer-fixed doctor-user-fixed" v-show="state.userInfo">
          <div class="doctor-user-footer" v-show="pageView">
            <div class="doctor-rank-item">
              <div class="doctor-rank-item-info">
                <i
                  class="c6 tc"
                  :class="
                    isNaN(parseInt(state.userInfo.topNo)) ? 'fs24' : 'fs29'
                  "
                  >{{
                    state.userInfo.topNo ? state.userInfo.topNo : '暂未上榜'
                  }}</i
                >
                <div
                  class="doctor-rank-item-pic"
                  :style="{
                    backgroundImage: 'url(' + state.userInfo.userHeadImage + ')'
                  }"
                ></div>
                <div class="doctor-user-item-info">
                  <span>{{ state.userInfo.userName }}</span>
                </div>
              </div>
              <div class="doctor-rank-item-times">
                <span v-show="state.userInfo.studyTime">{{
                  state.userInfo.studyTime
                }}</span>
              </div>
            </div>
          </div>
          <div class="ui-safe-area-inset"></div>
        </div>

        <!--        <div class="ui-footer-fixed rank-footer-fixed"
          @click="footerAction"
        >
          <div class="rank-footer ui-submit-button">
            <span>立即分享</span>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import utils from '@/public/utils'
import { Toast } from 'vant'
// import app from '@/widget/app'
import EHeader from '@/components/exercise/header/index.vue'
import DoctorTop from '@/components/rank/top.vue'
import DoctorList from '@/components/rank/list.vue'
import NoData from '@/components/rank/no-data.vue'
import { userReq } from '@/api/index'
const {
  proxy: { $showLoading, $hideLoading }
} = getCurrentInstance()
const topId = ref(1)
const topType = ref('day')
const isApp = ref(utils.isApp())
const topList = Object.freeze([
  {
    id: 1,
    name: '日榜',
    type: 'day'
  },

  {
    id: 2,
    name: '周榜',
    type: 'week'
  },
  {
    id: 3,
    name: '总榜',
    type: 'all'
  }
])

const navAction = (id, type) => {
  if (id === topId.value) {
    return
  }
  topId.value = id
  topType.value = type
  getRankList()
}

const footerAction = () => {
  // if (isApp.value) {
  //   app.appShare(JSON.parse(JSON.stringify(state.shareInfo.value)))
  // }
}
const state = reactive({
  bannerImage: '',
  hotList: [],
  rankList: [],
  topList: [],
  userInfo: Object.create(null),
  shareInfo: ref(Object.create(null))
})
const pageView = ref(false)

const getRankList = async () => {
  $showLoading()
  const res = await userReq.getRankList({
    userId: utils.getUserId(),
    type: topType.value
  })
  $hideLoading()
  if (Number(res.code) === 200) {
    const { self, list } = res.data
    pageView.value = true
    if (list.length > 1) {
      const first = list.shift()
      list.splice(1, 0, first)
    }
    state.hotList = list.slice(0, 3)
    state.rankList = list.slice(3)
    state.userInfo = self
    /*    state.shareInfo.value = {
      title: share.title,
      desc: share.description,
      image: share.image,
      url: share.url
    } */
  } else {
    Toast(res.message)
  }
}

onMounted(() => {
  getRankList()
})
</script>

<style lang="scss" scoped>
@import '~@/components/exercise/style/default.scss';
@import './index.scss';
</style>
